import { useCallback } from "react";
import { useAuthStore } from "@store/auth/auth";
import { useDestroyTokenMutation } from "@services/auth/mutations";
import { clearUserState } from "@utils/common";

export const useLogout = () => {
  const { token } = useAuthStore();
  const { mutateAsync: destroyToken, isPending } = useDestroyTokenMutation();

  const logout = useCallback(() => {
    void destroyToken(token!).catch(() => undefined);
    clearUserState();
  }, [destroyToken, token]);

  return { logout, isPending };
};
